import React from 'react';
import PropTypes, { string } from 'prop-types';
import PortalModal from '../../common/Modal/PortalModal';
import GenericButton from '../../common/GenericButton';
import { BASES_DATA_GRID, COLUMNS_DATA_GRID } from '../AutocodeConstants';

const modalStyles = {
  left: '40%',
  top: '30%',
  width: '334px',
  height: '191px,',
};

const ACCRBGridDeleteModal = props => {
  const { gridType, show, deleteHandler, closeHandler } = props;
  const gridName =
    gridType === BASES_DATA_GRID
      ? 'Bases'
      : gridType === COLUMNS_DATA_GRID
      ? 'Columns'
      : 'Rows';
  return (
    <div style={{ position: 'center' }} className="delete-modal">
      <PortalModal
        title="Delete"
        isShowing={show}
        dialogStyles={modalStyles}
        onCloseClicked={closeHandler}
      >
        Do you want to delete All {gridName}?
        <span style={{ whiteSpace: 'pre-line' }}>
          {'\n'}
          {'\n'}
        </span>
        <div className="text-center">
          <span className="pull-left">
            <GenericButton
              name="Cancel"
              btnStyle="cancel-button"
              onBtnClick={closeHandler}
            />
          </span>
          <span className="pull-right">
            <GenericButton
              name="Confirm"
              btnStyle="confirm-button"
              onBtnClick={deleteHandler}
            />
          </span>
          <span style={{ whiteSpace: 'pre-line' }}>
            {'\n'}
            {'\n'}
          </span>
        </div>
      </PortalModal>
    </div>
  );
};

ACCRBGridDeleteModal.propTypes = {
  gridType: string,
  show: PropTypes.bool,
  deleteHandler: PropTypes.func,
  closeHandler: PropTypes.func,
};

export default ACCRBGridDeleteModal;
